const IGN_URL = 'https://data.geopf.fr/wms-r/wms'
const IGN_WMTS_URL = 'https://data.geopf.fr/wmts'
const BRGM_GEOLOGIE_URL = 'https://geoservices.brgm.fr/geologie'
const BRGM_RISQUES_URL = 'https://geoservices.brgm.fr/risques'
const GEORISQUES_URL = 'https://mapsref.brgm.fr/wxs/georisques/risques'

// Newest first. Each one its own layer, because an aerial photograph is opaque and ticking a layer
// switches all of its sublayers on. The IGN also serves the individual years 2001 to 2024, which
// are left out to keep the list to the periods and the old maps. minScaleDenominator is the IGN's
// own MinScaleDenominator (levels 19, 18, 15 and 14).
const historicalImagery = [
  { id: 'ORTHOIMAGERY.ORTHOPHOTOS2021-2023', title: 'Photographies aériennes 2021-2023', minScaleDenominator: 1066.3647919248926 },
  { id: 'ORTHOIMAGERY.ORTHOPHOTOS2016-2020', title: 'Photographies aériennes 2016-2020', minScaleDenominator: 1066.3647919248926 },
  { id: 'ORTHOIMAGERY.ORTHOPHOTOS2011-2015', title: 'Photographies aériennes 2011-2015', minScaleDenominator: 2132.729583849782 },
  { id: 'ORTHOIMAGERY.ORTHOPHOTOS2006-2010', title: 'Photographies aériennes 2006-2010', minScaleDenominator: 2132.729583849782 },
  { id: 'ORTHOIMAGERY.ORTHOPHOTOS2000-2005', title: 'Photographies aériennes 2000-2005', minScaleDenominator: 2132.729583849782 },
  { id: 'ORTHOIMAGERY.ORTHOPHOTOS.1980-1995', title: 'Photographies aériennes 1980-1995', minScaleDenominator: 2132.729583849782 },
  { id: 'ORTHOIMAGERY.ORTHOPHOTOS.1965-1980', title: 'Photographies aériennes 1965-1980', minScaleDenominator: 2132.729583849782 },
  { id: 'ORTHOIMAGERY.ORTHOPHOTOS.1950-1965', title: 'Photographies aériennes 1950-1965', minScaleDenominator: 2132.729583849782 },
  { id: 'GEOGRAPHICALGRIDSYSTEMS.MAPS.SCAN50.1950', title: 'SCAN50 historique (1950)', minScaleDenominator: 17061.836670798282 },
  { id: 'GEOGRAPHICALGRIDSYSTEMS.ETATMAJOR40', title: "Carte de l'état-major (1820-1866)", minScaleDenominator: 17061.836670798282 },
  { id: 'BNF-IGNF_GEOGRAPHICALGRIDSYSTEMS.CASSINI', title: 'Carte de Cassini (XVIIIe siècle)', minScaleDenominator: 34123.673341596535 }
]

const timeTravelLayers = historicalImagery.map((edition) => ({
  name: edition.title,
  type: 'WMS',
  country: 'TijdreisFR',
  url: IGN_URL,
  minScaleDenominator: edition.minScaleDenominator,
  sublayers: [{ id: edition.id, title: edition.title }],
  invertMapTextColour: false
}))

export default [
  // The two opaque IGN backgrounds come first, so every French overlay below draws on top of them.
  // Tiled (WMTS) rather than drawn per request: both are pre-rendered by the IGN up to level 19,
  // and past that OpenLayers enlarges level 19 instead of showing nothing.
  {
    name: 'Plan IGN',
    type: 'WMTS',
    country: 'FR',
    url: IGN_WMTS_URL,
    matrixSet: 'PM_0_19',
    style: 'normal',
    format: 'image/png',
    sublayers: [{ id: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2', title: 'Plan IGN v2' }],
    invertMapTextColour: true
  },
  {
    // The infrared edition is a second opaque image, so it is left out rather than listed beside
    // this one where it would simply cover it.
    name: 'Photographies aériennes (IGN)',
    type: 'WMTS',
    country: 'FR',
    url: IGN_WMTS_URL,
    matrixSet: 'PM_0_19',
    style: 'normal',
    format: 'image/jpeg',
    sublayers: [{ id: 'ORTHOIMAGERY.ORTHOPHOTOS', title: 'BD ORTHO' }],
    invertMapTextColour: false
  },
  {
    name: 'Sites et sols pollués',
    type: 'WMS',
    country: 'FR',
    url: GEORISQUES_URL,
    // The registers behind Géorisques: where industry used to be, where the state is acting, and
    // which plots carry a legal soil notice. Polygons first, points over them.
    sublayers: [
      { id: 'SSP_CLASSIFICATION_SIS', title: "Secteurs d'information sur les sols" },
      { id: 'SSP_INSTRUCTION', title: 'Sites pollués appelant une action (ex-BASOL)' },
      { id: 'SSP_ETABLISSEMENT', title: 'Anciens sites industriels (ex-BASIAS)' },
      { id: 'INSTALLATIONS_CLASSEES_SIMPLIFIE', title: 'Installations classées' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Amiante environnemental',
    type: 'WMS',
    country: 'FR',
    url: BRGM_GEOLOGIE_URL,
    minScaleDenominator: 17500,
    // Coarse first so the 1/50 000 lands on top when the layer is switched on as a whole.
    sublayers: [
      { id: 'SUSCEPTIBILITE_AMIANTE_1M', title: 'Susceptibilité 1/1 000 000' },
      { id: 'SUSCEPTIBILITE_AMIANTE_50K', title: 'Susceptibilité 1/50 000' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Banque du Sous-Sol (BSS)',
    type: 'WMS',
    country: 'FR',
    url: BRGM_GEOLOGIE_URL,
    sublayers: [
      { id: 'BSS_TOTAL_AVEC_LABEL', title: 'Forages' },
      { id: 'BSS_EAU', title: "Points d'eau" }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Cadastre (IGN)',
    type: 'WMS',
    country: 'FR',
    url: IGN_URL,
    minScaleDenominator: 1066.3647919248926,
    sublayers: [{ id: 'CADASTRALPARCELS.PARCELLAIRE_EXPRESS', title: 'Parcellaire Express (PCI)' }],
    invertMapTextColour: true
  },
  {
    name: 'Carte géologique',
    type: 'WMS',
    country: 'FR',
    url: BRGM_GEOLOGIE_URL,
    minScaleDenominator: 9000,
    // Coarse first, so the 1/50 000 is what you get when the layer is switched on as a whole.
    sublayers: [
      { id: 'SCAN_F_GEOL1M', title: 'France au 1/1 000 000' },
      { id: 'SCAN_F_GEOL250', title: '1/250 000' },
      { id: 'SCAN_D_GEOL50', title: '1/50 000' }
    ],
    invertMapTextColour: true
  },
  {
    // Its own layer rather than a sublayer of the risks: it covers the whole country, so it would
    // hide any other area map switched on beside it.
    name: 'Retrait-gonflement des argiles',
    type: 'WMS',
    country: 'FR',
    url: BRGM_RISQUES_URL,
    sublayers: [{ id: 'ALEARG', title: 'Exposition au retrait-gonflement' }],
    invertMapTextColour: true
  },
  {
    name: 'Remontées de nappes',
    type: 'WMS',
    country: 'FR',
    url: BRGM_RISQUES_URL,
    sublayers: [{ id: 'REMNAPPE_FR', title: 'Carte nationale des remontées de nappes' }],
    invertMapTextColour: true
  },
  {
    name: 'Cavités et mouvements de terrain',
    type: 'WMS',
    country: 'FR',
    url: BRGM_RISQUES_URL,
    sublayers: [
      { id: 'CAVITE_LOCALISEE', title: 'Cavités souterraines' },
      { id: 'MVT_LOCALISE', title: 'Mouvements de terrain' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Relief',
    type: 'WMS',
    country: 'FR',
    url: IGN_URL,
    minScaleDenominator: 2132.729583849782,
    // The shading carries the relief and the contours draw on top of it. The elevation grid itself
    // is data rather than a picture and this service refuses to draw it.
    sublayers: [
      { id: 'ELEVATION.ELEVATIONGRIDCOVERAGE.SHADOW', title: 'Estompage' },
      { id: 'ELEVATION.CONTOUR.LINE', title: 'Courbes de niveau' }
    ],
    invertMapTextColour: true
  },
  ...timeTravelLayers
]
